var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"achtergrond",attrs:{"ma":"0","pa":"0"}},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__slideInDown","appear":""}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }